function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var convertLimitStringToNumber = function(input) {
    var regex = /^(\d+\.?\d*)([KMGT]?)$/;
    var match = regex.exec(input.toUpperCase());
    if (!match) return 0;
    var numberPart = parseFloat(match[1]);
    var magnitudePart = match[2];
    switch(magnitudePart){
        case "K":
            return numberPart * 1000;
        case "M":
            return numberPart * 1000000;
        case "G":
            return numberPart * 1000000000;
        case "T":
            return numberPart * 1000000000000;
        default:
            return numberPart;
    }
};
export var convertLimitToString = function(input) {
    if (input >= 1000000000000) {
        return (input / 1000000000000).toFixed(2) + "T";
    } else if (input >= 1000000000) {
        return (input / 1000000000).toFixed(2) + "G";
    } else if (input >= 1000000) {
        return (input / 1000000).toFixed(2) + "M";
    } else if (input >= 1000) {
        return (input / 1000).toFixed(2) + "K";
    } else {
        return String(input);
    }
};
export var TIER_HEADERS = /*#__PURE__*/ function(TIER_HEADERS) {
    TIER_HEADERS["accountUsage"] = "X-AccountUsage-Limit";
    TIER_HEADERS["assetsUsage"] = "X-AssetsUsage-Limit";
    TIER_HEADERS["deploymentDebugInstances"] = "X-DeploymentDebugInstances-Limit";
    TIER_HEADERS["deploymentDomains"] = "X-DeploymentDomains-Limit";
    TIER_HEADERS["deploymentInstances"] = "X-DeploymentInstances-Limit";
    TIER_HEADERS["marketplaceWorkspaces"] = "X-MarketplaceWorkspaces-Limit";
    TIER_HEADERS["numberQueues"] = "X-NumberQueues-Limit";
    TIER_HEADERS["queueInflight"] = "X-QueueInflight-Limit";
    TIER_HEADERS["queueMessageSizeBytes"] = "X-QueueMessageSizeBytes-Limit";
    TIER_HEADERS["queueRate"] = "X-QueueRate-Limit";
    TIER_HEADERS["queuedElements"] = "X-QueuedElements-Limit";
    TIER_HEADERS["rps"] = "RPS";
    TIER_HEADERS["schedulerJobs"] = "X-SchedulerJobs-Limit";
    return TIER_HEADERS;
}({});
var _obj;
export var tierLimitNames = (_obj = {}, _define_property(_obj, "RPS", {
    hint: "The maximum number of requests that a user can make within a<br/> \ngiven time period",
    icon: "filter-solid",
    name: "Request rate limits",
    units: "rps"
}), _define_property(_obj, "X-AccountUsage-Limit", {
    docs: {
        title: "learn more",
        url: "https://developer.vonage.com/en/vonage-cloud-runtime/providers/state?source=vonage-cloud-runtime"
    },
    hint: "Non-relational database that stores data as a collection of <br/>\nkey–value pairs",
    icon: "pie-chart-solid",
    name: "Key Value Store",
    units: "B"
}), _define_property(_obj, "X-AssetsUsage-Limit", {
    docs: {
        title: "learn more",
        url: "https://developer.vonage.com/en/vonage-cloud-runtime/providers/assets?source=vonage-cloud-runtime"
    },
    hint: "Store and retrieve objects",
    icon: "packet-solid",
    name: "Assets storage",
    units: "B"
}), _define_property(_obj, "X-DeploymentInstances-Limit", {
    hint: "A version of your code that you can set up separately for testing<br/>\n or production use",
    icon: "ai-solid",
    name: "Number of instances deployed",
    units: ""
}), _define_property(_obj, "X-DeploymentDebugInstances-Limit", {
    icon: "ai-line",
    name: "Deployment debug instances",
    units: ""
}), _define_property(_obj, "X-DeploymentDomains-Limit", {
    icon: "globe-solid",
    name: "Deployment domains",
    units: ""
}), _define_property(_obj, "X-MarketplaceWorkspaces-Limit", {
    hint: "An editable environment (also known as a workspace) where you<br/> \n customize your code and settings before deploying it as a test or<br/>\n production instance",
    icon: "code-solid",
    name: "Number of templates",
    units: ""
}), _define_property(_obj, "X-NumberQueues-Limit", {
    docs: {
        title: "learn more",
        url: "https://developer.vonage.com/en/vonage-cloud-runtime/providers/queue?source=vonage-cloud-runtime"
    },
    hint: "Max number of queues allowed per account",
    icon: "reorder-vertical-solid",
    name: "Max Queues number",
    units: " per API Key"
}), _define_property(_obj, "X-QueueInflight-Limit", {
    hint: "The maximum number of messages delivered to clients but not yet confirmed as processed",
    icon: "bring-to-front-solid",
    name: "Max queues inflight",
    units: " per queue"
}), _define_property(_obj, "X-QueueMessageSizeBytes-Limit", {
    hint: "The maximum allowable size of a single queue message",
    icon: "file-add-solid",
    name: "Max message size",
    units: "B"
}), _define_property(_obj, "X-QueueRate-Limit", {
    hint: "The maximum number of messages delivered to a client per second",
    icon: "stream-solid",
    name: "Max queue rate",
    units: " per queue"
}), _define_property(_obj, "X-QueuedElements-Limit", {
    hint: "The maximum total number of messages a single queue can store",
    icon: "density-high-solid",
    name: "Max enqueued messages",
    units: " per queue"
}), _define_property(_obj, "X-SchedulerJobs-Limit", {
    docs: {
        title: "learn more",
        url: "https://developer.vonage.com/en/vonage-cloud-runtime/providers/scheduler?source=vonage-cloud-runtime"
    },
    hint: "Schedule functions to be run at a specified time in the future,<br/>\nor to recur based on an interval",
    icon: "clock-solid",
    name: "Scheduler jobs",
    units: ""
}), _obj);

//# sourceMappingURL=tiers.js.map